<footer class="{{(routeName === '/home-script' ? 'home-footer' : '')}}">
    <div class="container">
        <div>
            <div class="mat-caption d-inline"> v 2.0.0 </div>
            <p i18n="@@copyRights" class="mat-caption d-inline p-2"> Copyrights © 2020-2026 Sales Script </p>
            <p i18n="@@privacyStatement" data-testid="privacy_link" (click)="navigateTo('/privacy')" class="mat-caption d-inline p-2 cursor">Privacy Statement</p>
            <p i18n="@@termsAndConditions" data-testid="terms_link" (click)="navigateTo('/terms')" class="mat-caption d-inline p-2 cursor">Terms And Conditions</p>
        </div>
        <div class="social-media d-flex align-items-center justify-content-end">
            <a data-testid="mail_link" href="mailto:info@s2cript.com" i18n-title title="Email">
                <mat-icon svgIcon="mail"></mat-icon>
            </a>
            <a data-testid="phone_link" href="tel:+31654902501" i18n-title title="Phone">
                <mat-icon svgIcon="phone"></mat-icon>
            </a>
            <a data-testid="address_link" href="http://maps.google.com/?q=Het Hout 16, 6846 EB, Arnhem, the Netherlands" i18n-title title="Address">
                <mat-icon svgIcon="address"></mat-icon>
            </a>
            <a data-testid="linkedin_link" href="https://www.linkedin.com/company/s2cript-b-v/" i18n-title title="LinkedIn">
                <mat-icon svgIcon="linkedin"></mat-icon>
            </a>
            <a data-testid="facebook_link" href="https://www.facebook.com/S2CRIPT/" i18n-title title="Facebook">
                <mat-icon svgIcon="facebook"></mat-icon>
            </a>
        </div>
    </div>
</footer>